import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {ManageOrganisationService} from './manage-organisation.service';
import {YourPlaceListing} from '../models/your-place/your-place-listing';
import {ZooplaBranch} from '../models/zoopla/zoopla-branch';
import {ZooplaBranchPost} from '../models/zoopla/zoopla-branch-post';
import {Observable} from 'rxjs';
import {ZooplaApiListing} from '../models/zoopla/zoopla-api-listing';
import {ZooplaListingPost} from '../models/zoopla/zoopla-listing-post';
import {ZooplaListing} from '../models/zoopla/zoopla-listing';

@Injectable({
    providedIn: 'root',
})
export class ZooplaService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private manageOrganisationService: ManageOrganisationService) {
    }

    getBranches(){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/branches`
        return this.http.get<ZooplaBranch[]>(url);
    }

    addBranch(model: ZooplaBranchPost){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/branches`
        return this.http.post<void>(url, model);
    }

    updateBranch(branchReference: string, model: ZooplaBranchPost){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/branches/${branchReference}`
        return this.http.patch<void>(url, model);
    }

    deleteBranch(branchReference: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/branches/${branchReference}`
        return this.http.delete<void>(url);
    }

    getBranchListingsList(branchReference: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/branches/${branchReference}/listings/list`
        return this.http.get<ZooplaApiListing[]>(url);
    }

    getListings(propertyReference: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/listings`
        return this.http.get<ZooplaListing[]>(url, {
            params: {
                propertyReference
            }
        });
    }

    getListing(listingReference: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/listings/${listingReference}`
        return this.http.get<ZooplaListing>(url);
    }

    deleteBranchListing(listingReference: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/listings/${listingReference}`
        return this.http.delete<void>(url);
    }

    addBranchListing(model: ZooplaListingPost){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/listings`
        return this.http.post<{ listingReference: string }>(url, model);
    }

    updateListing(listingReference: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/zoopla/listings/${listingReference}/update`
        return this.http.post<void>(url, null);
    }
}
